import { api } from './client';

export const DevicesAPI = {
  // GET /devices  -> { status: true, data: [...] }
  list: () => api.get('/devices'),
  // GET /devices/:id/software?q=&limit=&offset=
  software: (deviceId, params) => api.get(`/devices/${deviceId}/software`, { params }),
};